import { render, staticRenderFns } from "./ExportAssets.vue?vue&type=template&id=4458441c"
import script from "./ExportAssets.vue?vue&type=script&lang=js"
export * from "./ExportAssets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports